export class Indians {
	defaultOptions() {
		this.$options = {
			indians: {
				blok: null,
				sloz: null,
				jine_bota: null,
				jine_odtah: null,
				jine_jine: null,
			},
			indianPayment: {
				inv: null,
				cash: null,
				card: null,
			},
			fees: {
				prisonBall: 0,
				towing: 0,
			},
			structure: {
				clean: {
					".js-indian-number": {
						'css': {display: "none"},
						'classRemove': ["payment-dependent", "payment-display-cash"],
					},
					".js-invoice-number": {
						'css': {display: "none"},
						'classRemove': ["payment-dependent", "payment-display-inv", "use-prison-ball-number", "use-towing-number"],
					},
					".js-payment-type": {'css': {display: "block"}},
					".js-indian-description": {'css': {display: "none"}},
				},
				blok: {
					".js-indian-number": {'css': {display: "block"}},
				},
				sloz: {
					".js-indian-number": {'css': {display: "block"}},
					".js-invoice-number": {'css': {display: "block"}},
				},
				jine: {
					".js-indian-number": {
						'css': {display: ""},
						'classAdd': ["payment-dependent", "payment-display-cash"],
					},
					".js-invoice-number": {
						'css': {display: ""},
						'classAdd': ["payment-dependent", "payment-display-inv"],
					},
					".js-indian-description": {'css': {display: "block"}},
				},
				jine_bota: {
					".js-invoice-number": {
						'classAdd': ["use-prison-ball-number"],
					},
				},
				jine_odtah: {
					".js-invoice-number": {
						'classAdd': ["use-towing-number"],
					},
				},
				jine_jine: {},
			}
		};
	};
	
	constructor () {
		var options = $('#js-opts').data('indian');
		this.defaultOptions();
		this.$options = $.extend({}, this.$options, options || {});
		$('#wrongDoingsForm').validator();

		this.handleButtons();
		this.setupIndians();
	}

	//---------------------------------------------------------------------

	addIndian ($button) {
		this.addIndianByType($button.data('type'));
	}

	addIndianByType (type) {
		var app = this,
			tpl = $('#js-indian-template').html(),
			title = app.$options.indians[type].title,
			$list = $('#indians-list'),
			key = getNextKey($list),
			types = app.$options.indians;

		tpl = tpl.replace(/\{\{type\}\}/g, type);
		tpl = tpl.replace(/\{\{title\}\}/g, title);
		tpl = tpl.replace(/\{\{key\}\}/g, key);

		$list.append(tpl);

		var $el = $list.find('#indian_'+key);
		$el.find('.tooltips').tooltip();

		if (type == types.sloz.key) {
			$el.find('.js-payment-type-select').val(app.$options.indianPayment.inv);
		}
		app.setupIndianByType(type, $el, false);
		$.each($el.find('.post-setup-whisperer'), function (i, select) {
			window.$whisperers.initSelect($(select), null);
		});

		return $el;
	}

	changeIndianType ($button) {
		var app = this,
			$indianBlock = $button.closest('.wd-indian'),
			newType = $button.data('type'),
			key = $indianBlock.data('key');

		$indianBlock.find('input[name="indians['+key+'][type]"]').val(newType);

		var block = $indianBlock.get(0);
		if (block) {
			block.className = block.className.replace(/\s*(type-[^\s"']*)/, " type-" + newType);
		}

		if (newType == app.$options.indians.sloz.key) {
			$indianBlock.find('.js-payment-type-select').val(app.$options.indianPayment.inv);
		}

		app.setupIndianByType(newType, $indianBlock, false);
	}

	setupIndians () {
		var app = this;
		$('.panel.wd-indian').each(function (i, el) {
			var $block = $(el);
			if ( ! $block.hasClass("js-tpl") ) {
				app.setupIndianByType( $block.data('type'), $block, true );
			}
		});
	}

	setupIndianByType (type, $block, initialSetup) {
		var app = this,
			types = app.$options.indians,
			lang = $Lang.wrongDoings.indian,
			struct = app.$options.structure;

		$block.data('type', type);

		//Setup common properties 
		$block.find('.js-title').text(lang.add[type]);
		$block.find(".js-number-label").text(lang.number[type]);
		$block.find(".js-label-fee").text(lang.price[type]);
		$block.find(".js-awarded-by-label").text(lang.awardedBy[type]);

		//Adjust the structure
		//clean
		app.setupIndianStructure($block, struct.clean);
		//set common for "jine"
		if (type.indexOf('jine') >= 0)
		{
			app.setupIndianStructure($block, struct.jine);
		}
		//set properties for selected type
		app.setupIndianStructure($block, struct[type]);
		//set number inputs
		if (!initialSetup) {
			app.setIndianNumberByType($block, type);
			//update wrong doing state
			app.setWrongDoingStateByIndians();
		}

		//Check payment type
		var selectedType = $block.find('.js-payment-type-select').val();
		app.setupIndianByPaymentType($block, selectedType);
	}

	setupIndianStructure ($block, structure) {
		$.each(structure, function (selector, data) {
			var $el = $block.find(selector);
			if ( 'css' in data ) {
				$el.css(data.css);
			}
			if ( 'classRemove' in data ) {
				$.each(data.classRemove, function (i, className) {
					$el.removeClass(className);
				});
			}
			if ( 'classAdd' in data ) {
				$.each(data.classAdd, function (i, className) {
					$el.addClass(className);
				});
			}
		});
	}

	setupIndianByPaymentType ($block, paymentType) {
		var app = this,
			types = app.$options.indianPayment;
		if ( paymentType == types.inv ) {
			$block.removeClass('payment-type-' + types.cash);
			$block.addClass('payment-type-' + types.inv);
		}
		else {
			$block.removeClass('payment-type-' + types.inv);
			$block.addClass('payment-type-' + types.cash);

			//Check indian number
			if ($block.find('.indian-number > .form-group').children().length == 0) {
				app.setIndianNumberByType($block, $block.data('type'));
			}
		}
	}

	setIndianNumberByType ($block, type) {
		var $field = $block.find(".js-indian-number"),
			$label = $field.find("label"),
			$inputs = $field.find(".indian-number"),
			key = $block.data('key'),
			typeProperties = this.$options.indians[type];
		$inputs.html("");

		$label.text(typeProperties.label);
		var inputsHtml = "";
		$.each (typeProperties.inputs, function (index, length) {
			inputsHtml += "<input" +
				" name=\"indians[" + key + "][numbers][" + (index+1) + "]\"" +
				" class=\"form-control lc-all-up indian-number-" + length + "\"" +
				" id=\"indian-Number" + (index+1) + "-" + key + "\"" +
				" type=\"text\"" +
				" value=\"\">";
		});
		$inputs.append($("<div class=\"form-group\">" + inputsHtml + "</div>"));
	}

	setWrongDoingStateByIndians () {
		var $select = $('#state'),
			app = this,
			state = window.$Common.states,
			indianType = app.$options.indians,
			$indians = $('.wd-indians .panel.wd-indian'),
			newState = null,
			blokFound = false,
			slozFound = false;

		$indians.each(function (i, indianBlock) {
			var $block = $(indianBlock),
				type = $block.data('type');

			switch (type) {
				case indianType.sloz.key:
					slozFound = true;
					newState = state.ST_SLOZENKOU;
					break;

				case indianType.blok.key:
					blokFound = true;
					newState = state.ST_BLOKOVE;
					break;

				default:
					break;
			}
		});

		if (blokFound && slozFound)
		{
			newState = state.ST_NEVYRESENO;
			$('.wd-indian.type-blok').addClass('has-error');
			$('.wd-indian.type-sloz').addClass('has-error');
		}
		else
		{
			$('.wd-indian.type-blok').removeClass('has-error');
			$('.wd-indian.type-sloz').removeClass('has-error');
		}
		if (null !== newState)
		{
			$select.val(newState);
		}
	}

	solveStateChange ($select) {
		var app = this,
			state = app.$options.states,
			indianType = app.$options.indians;

		$('.wd-indians .wd-indian').removeClass('has-error');

		switch ($select.val()) {
			case state.ST_BLOKOVE:
				if ($('.wd-indians .wd-indian.type-blok').length == 0) {
					app.addIndianByType(indianType.blok.key);
				}
				break;

			case state.ST_SLOZENKOU:
				if ($('.wd-indians .wd-indian.type-sloz').length == 0) {
					app.addIndianByType(indianType.sloz.key);
				}
				break;


			case state.ST_SPRAVNI_RIZENI:
				var today = new Date(),
					todayDate = today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();
				$('#notificationDate').val(todayDate);
			//NOBREAK !!!
			case state.ST_NEPROKAZAN:
				$('.wd-indians .wd-indian.type-jine_bota').addClass('has-error');
				$('.wd-indians .wd-indian.type-jine_odtah').addClass('has-error');
			//NOBREAK !!!

			case state.ST_PCR:
			case state.ST_DOMLUVOU:
			case state.ST_NAPOMENUTI:
				$('.wd-indians .wd-indian.type-blok').addClass('has-error');
				$('.wd-indians .wd-indian.type-sloz').addClass('has-error');
				break;
		}
	}

	addPrisonBallFeeIndian (checked) {
		var app = this,
			indianType = app.$options.indians;

		if (checked) {
			var $block = app.addIndianByType(indianType.jine_bota.key);
			$block.find('.js-price input').val(app.$options.fees.prisonBall);
			$block.addClass('js-prison-ball-automatic-fee');
		}
		else
		{
			$('.wd-indian.js-prison-ball-automatic-fee').remove();
		}
	}

	addTowingFeeIndian (checked) {
		var app = this,
			indianType = app.$options.indians;

		if (checked) {
			var $block = app.addIndianByType(indianType.jine_odtah.key);
			$block.find('.js-price input').val(app.$options.fees.towing);
			$block.addClass('js-towing-automatic-fee');
		}
		else
		{
			$('.wd-indian.js-towing-automatic-fee').remove();
		}
	}

	clearSolution () {
		var app = this;

		bootbox.confirm({
			'title' : $Lang.wrongDoings.indian.clearSolutionTitle,
			'message' : $Lang.wrongDoings.indian.clearSolutionConfirm,
			'callback'  (result) {
				if (result) {
					app.clearSolutionFinish();
				}
			}
		});
	}

	clearSolutionFinish () {
		var states = window.$Common.states,
			$indiansBlock = $('.wd-indians'),
			$select = $indiansBlock.find('select#state');

		$select.parent().removeClass('input-group');
		$select.removeAttr('disabled').val(states.ST_NEVYRESENO);

		$indiansBlock.find('#indians-list .wd-indian.type-sloz, #indians-list .wd-indian.type-blok').remove();
		$indiansBlock.find(' .add-indian-button').removeClass('hidden');
		$indiansBlock.find('.js-clear-solution').remove();
		$indiansBlock.find('.js-remove-block').removeClass('disabled');
		$('#notificationDate').val("").trigger('change');
	}

	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document);

		$document.on('click', '.add-indian', function (e) {
			e.preventDefault();
			app.addIndian($(this));
		});

		$document.on('change', '#state', function (e) {
			e.preventDefault();
			app.solveStateChange($(this));
		});

		$document.on('click', '.wd-indian a.js-change-type', function (e) {
			e.preventDefault();
			app.changeIndianType($(this));
		});

		$document.on('click', '.js-clear-solution', function () {
			app.clearSolution();
		});

		$document.on('focus', '.js-indian-price input', function () {
			$(this).select();
		});

		$document.on('change', '.js-payment-type-select', function () {
			var $select = $(this);
			app.setupIndianByPaymentType($select.closest('.panel.wd-indian'), $select.val());
		});

		if (app.$options.fees.prisonBall > 0) {
			$document.on('change', '#prisonBall', function () {
				app.addPrisonBallFeeIndian(this.checked);
			});
		}

		$document.on('change', '#towingExists', function () {
			app.addTowingFeeIndian(this.checked);
		});
	}
}
window.$indians = new Indians();
